import { connect } from "react-redux";
import { getLanguages } from "@insite/client-framework/Store/Context/ContextSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import React from "react";
import siteMessage from "@insite/client-framework/SiteMessage";
import Typography from "@insite/mobius/Typography";
import WidgetModule from "@insite/client-framework/Types/WidgetModule"; 

// The `ApplicationState` type represents the entire Redux store 
// for the Spire Storefront. 
const mapStateToProps = (state: ApplicationState) => ({
     // Selectors are provided to access parts of the Redux store 
     // more easily. If a selector is available to access the part of 
     // the store you need, you should use the selector instead of 
     // navigating the store manually. 
     languages: getLanguages(state), 
}); 

type Props = ReturnType<typeof mapStateToProps>; 
const ReduxConnectedWidget = (props: Props) => { 
    if (!props.languages || props.languages.length === 0) {
         return ( 
             // For longer text strings that are displayed to the user,
              // you should use site messages. The `siteMessage` function
               // will retrieve the site message configured in the Admin Console. 
               <Typography>{siteMessage("This site has no languages configured.")}</Typography> );
    } return ( 
        <ul> {props.languages.map(lang => (
             <li key={lang.id}> {
                /* Whenever you display text, you should try to do so using a Mobius component. This will ensure that the styles from the Mobius theme are used. */}
         <Typography>{lang.description}</Typography> </li> ))} </ul> ); 
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ReduxConnectedWidget),
    definition: { fieldDefinitions: [], group: "Common", }
}; 
 
export default widgetModule;
